// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1lgiH","consentsList":"PatientConsents_consentsList__2T7OF","consentsListEmpty":"PatientConsents_consentsListEmpty__3pKcN"};